/**
 * @license
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
export class InitServer {
    #transport;
    constructor(transport) {
        this.#transport = transport;
    }
    async serve() {
        const stream = this.#transport.createServerStream();
        const reader = stream.readableRequests.getReader();
        const request = await reader.read();
        if (request.done) {
            throw new Error("Client closed stream without sending a request.");
        }
        return request.value.url;
    }
}
export class InitClient {
    #transport;
    constructor(transport) {
        this.#transport = transport;
    }
    async load(url) {
        const stream = this.#transport.createClientStream();
        const writer = stream.writableRequests.getWriter();
        await writer.write({ url });
        await writer.close();
    }
}
//# sourceMappingURL=init.js.map